import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../core/models/contact-type.model'
import { MatButton, MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'
import { DocumentTypeService } from '../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatTableModule } from '@angular/material/table'
import { provideNgxMask } from 'ngx-mask'
import { PassengerService } from '../../core/services/passenger/passenger.service'
import { PassengerOrdemService } from '../../core/services/passenger/passenger-os/passenger-os.service'
import { PassagersModalComponent } from './passengers-modal/passengers-modal.component'
import { PassengersEditComponent } from './passengers-edit/passengers-edit.component'
import { MatSpinner } from '@angular/material/progress-spinner'
import { MatDivider } from '@angular/material/divider'
import { SnackbarCustomService } from '../../shared/components/snackbar/snackbar-custom.service'
import { PassagersImportExcelComponent } from './passengers-import-excel/passengers-import-excel.component'
import { TableListPassangersComponent } from '../../shared/components/table-list-passangers/table-list-passangers.component'


@Component({
  selector: 'passengers',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatButtonModule,
    MatSelectModule,
    MatProgressBar,
    MatIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDivider,
    MatSpinner,
    TableListPassangersComponent
  ],
  templateUrl: './passengers.component.html',
  styleUrl: './passengers.component.scss',
  standalone: true,
  providers: [provideNgxMask({
    dropSpecialCharacters: false
  })],
})
export class PassagersComponent implements OnInit {
  @Output() valid = new EventEmitter<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private passangerService: PassengerService,
    private passangerOs: PassengerOrdemService,
    private documentTypeService: DocumentTypeService,
    private snackbar: SnackbarCustomService,
  ) { }

  @Output() response = new EventEmitter<any>()
  @Input() itemOs: any
  @Input() dataSource: any[] = []


  form!: FormGroup;
  passengers: any[] = [];
  loading = false;
  buttonDisable = false;

  documentMask = '';
  columns: any[] = [
    {
      keyColumn: 'nome',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'documento',
      key: 'documento',
      description: 'Documento',
    },
    {
      keyColumn: 'contato',
      key: 'contato',
      description: 'Contato',
    },
    {
      keyColumn: 'companhia',
      key: 'companhia',
      description: 'Companhia',
    },
    {
      keyColumn: 'periodo',
      key: 'periodo',
      description: 'Periodo',
    },
    {
      keyColumn: 'voo',
      key: 'voo',
      description: 'Voo',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    }
  ];

  cellphoneMask = '(00) 00000-0000';

  page = 1;
  rows = 10;
  numberRows = 0;
  itemsList: any[] = []
  passengerOsList: any[] = []
  allowedTypes = []
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  file: File | null = null


  editIndex: number | null = null;
  editAgendaItem: any = null;

  documentTypeList = [
    { id: 'cpf', descricao: 'CPF' },
    { id: 'rg', descricao: 'RG' },
    { id: 'cnh', descricao: 'CNH' }
  ];

  ngOnInit(): void {
    this.createForm();
    this.getPassengersFromApi();


  }

  createForm(): void {
    this.form = this.formBuilder.group({
      nomePassageiro: [''],
      tipoDocumento: [''],
      numeroDoc: [''],
      contato: [''],
      companhia: [''],
      voo: [''],
      file: ['', Validators.required],
    });
  }


  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  getListItems() {
    this.loading = true
    this.passangerService
      .listPagedPassenger(this.page, this.rows)
      .subscribe({
        next: (response: any) => {

          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }


  createModelExcel(): FormData {
    const formData = new FormData();
    formData.append('ExcelFile', this.file!, this.file!.name);
    formData.append('OsId', this.data.idOs);
    return formData;
  }

  createFile() {
    if (!this.file) {
      console.error('Nenhum arquivo selecionado');
      return;
    }

    this.loading = true;
    const formData = this.createModelExcel();

    this.passangerOs.excelUploadPassengerOs(formData).subscribe({
      next: (res) => {
        this.snackbar.success('Passageiros importados com sucesso');
        this.response.emit({ action: 'create', item: res });
        this.getPassengersFromApi();
      },
      error: (err) => {
        this.snackbar.errorRequest('Error ao fazer importação de passageiros');
        this.loading = false;
      },
      complete: () => {
        this.resetForm();

      }
    });
  }

  searchListItems() {
    this.loading = true
    this.passangerService
      .listPagedPassenger(this.page, this.rows)
      .subscribe({
        next: (response: any) => {

          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  formatHour(time: any): string {
    if (!time) return '';
    // Se vier como Date, converte para string
    if (time instanceof Date) {
      return time.toTimeString().slice(0, 5);
    }
    // Se vier como string "HH:mm:ss", pega só "HH:mm"
    if (typeof time === 'string' && time.length >= 5) {
      return time.slice(0, 5);
    }
    return time;
  }


  treatResponse(response: any) {
    const list = []
    // Se precisar filtrar por OS aqui também:
    if (response.data) {

      for (const item of response.data) {
        list.push({
          ...item,
          horaPartida: this.formatHour(item.horaPartida),
          horaChegada: this.formatHour(item.horaChegada),
          // Valores (já vem formatados, mas garanta que não seja vazio)
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens;

  }

  addItemToList() {
    const idOs = this.data.idOs
    const dialogRef = this.dialog.open(PassagersModalComponent, {
      id: 'passengers-modal',
      data: { idOs },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1050px',
      width: '1050px',
      maxHeight: '400px',
      height: '400px',

    })
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.getPassengersFromApi();
        this.snackbar.success('Passageiro adicionado com sucesso.');
      }
    });
  }

  importExcel() {
    const idOs = this.data.idOs
    const dialogRef = this.dialog.open(PassagersImportExcelComponent, {
      id: 'passengers-modal',
      data: { idOs },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '800px',
      width: '800px',
      maxHeight: '250px',
      height: '250px',

    })
    dialogRef.afterClosed().subscribe(() => {
      this.getPassengersFromApi();
      // this.snackbar.success('Passageiro adicionado com sucesso.');

    });
  }

  editItem(element: any) {
    const idOs = this.data.idOs
    const idPassageiro = element.passageiroId

    const dialogRef = this.dialog.open(PassengersEditComponent, {
      id: 'passengenrs-edit',
      data: { idOs, idPassageiro },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1050px',
      width: '1050px',
      maxHeight: '400px',
      height: '400px',


    })
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.getPassengersFromApi()
        this.snackbar.success('Passageiro editado com sucesso.');
      }
    });
  }

  getPassengersFromApi(): void {
    this.loading = true;

    const idOs = {
      ordemServicoId: this.data.idOs
    }

    this.passangerOs.listPassengerByOs(idOs).subscribe({
      next: (dados) => {
        this.treatResponse(dados)
        const allPassengers = dados.data || []

        this.passengers = allPassengers;
        this.numberRows = allPassengers.length;


        if (allPassengers.length >= this.itemOs.quantidadePassageiros) {
          this.buttonDisable = true
        } else {
          this.buttonDisable = false
        }

        if (allPassengers.length > 0) {
          this.valid.emit(allPassengers.length > 0);
        } else {
          this.valid.emit(false);
        }


        if (allPassengers.length > 0) {
          this.valid.emit(true);
        } else {
          this.valid.emit(false);
        }
        this.loading = false;
      },
      error: (err) => {

        console.error('Erro ao buscar passageiros:', err);
        this.loading = false;
      }
    });
  }



  deleteItem(item: any) {
    this.loading = true
    this.passangerOs.deletePassengerOs(item.id).subscribe({
      next: () => {

        this.snackbar.success('Passageiro excluído com sucesso.');
        this.getPassengersFromApi()

      },
      error: (err) => {
        this.snackbar.error('Erro ao excluir passageiro.');
      },
    });
  }


  onDocumentTypeChange(type: string) {
    if (type === 'cpf') {
      this.documentMask = '000.000.000-00';
    } else if (type === 'rg') {
      this.documentMask = '00.000.000-0';
    } else if (type === 'cnh') {
      this.documentMask = '00000000000';
    } else {
      this.documentMask = '';
    }
    this.form.get('numeroDoc')?.reset();
  }

  cancel() {
    this.editIndex = null;
    this.response.emit({ action: 'cancel' });
    this.resetForm();
  }

  resetForm() {
    this.form.reset();
  }
}
